module.exports = __webpack_public_path__ + "img/024.53bbb478.jpg";